import { OptionModel } from "./option.model"
import { SimpleAttributeModel } from "./simple-attribute.model"

export class SimpleOptionsAttributeModel extends SimpleAttributeModel {
    key: string
    value?: string
    type: string
    attributes?: SimpleAttributeModel[]
    options?: OptionModel[]

    constructor() {
        super()
        this.options = []
    }
}